import React from 'react'

function Hello() {
	return (
		<div></div>
	)
}

export default Hello